/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assetlibrarypickerloaderror4Inputs */

const en_assetlibrarypickerloaderror4 = /** @type {(inputs: Assetlibrarypickerloaderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load the selected image.`)
};

const de_assetlibrarypickerloaderror4 = /** @type {(inputs: Assetlibrarypickerloaderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ausgewählte Bild konnte nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "Could not load the selected image." |
*
* @param {Assetlibrarypickerloaderror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const assetlibrarypickerloaderror4 = /** @type {((inputs?: Assetlibrarypickerloaderror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assetlibrarypickerloaderror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_assetlibrarypickerloaderror4(inputs)
	return de_assetlibrarypickerloaderror4(inputs)
});
export { assetlibrarypickerloaderror4 as "assetLibraryPickerLoadError" }